import { createIcon } from '@chakra-ui/icons';

export const LockFilled = createIcon({
  displayName: 'LockFilled',
  viewBox: '0 0 20 23',
  path: [
    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.25 9.58325H1.91667C0.857708 9.58325 0 10.441 0 11.4999V21.0833C0 22.1422 0.857708 22.9999 1.91667 22.9999H17.25C18.309 22.9999 19.1667 22.1422 19.1667 21.0833V11.4999C19.1667 10.441 18.309 9.58325 17.25 9.58325ZM9.58333 18.2083C8.52437 18.2083 7.66667 17.3505 7.66667 16.2916C7.66667 15.2326 8.52437 14.3749 9.58333 14.3749C10.6423 14.3749 11.5 15.2326 11.5 16.2916C11.5 17.3505 10.6423 18.2083 9.58333 18.2083Z"
        fill="currentColor"
      />
      <path
        d="M15.3359 7.66668H13.4193V5.75001C13.4413 3.65701 11.7642 1.94159 9.67123 1.91668H9.63098C7.52552 1.88026 5.78902 3.55638 5.7526 5.66184V5.66472V7.66668H3.83594V5.65418C3.86756 2.52618 6.40906 0.00575966 9.53706 9.66482e-06H9.59552C12.7599 -0.00574033 15.3302 2.55493 15.3359 5.71934C15.3359 5.73276 15.3359 5.74618 15.3359 5.75959V7.66668Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
